import { Col, Row } from "react-bootstrap";

function Loading() {
  return  (
    <Row>
      <Col sm={5} className="text-right" />
      <Col sm={2} className="text-center">
        <div className="center spinner-container">
          <div className="loading-spinner" />
        </div>
      </Col>
      <Col sm={5} className="text-right" />
    </Row>
  );
}

export default Loading;